__turbopack_context__.v({
  "bookBtn": "Cart-module__Lov9ca__bookBtn",
  "card": "Cart-module__Lov9ca__card",
  "cardBody": "Cart-module__Lov9ca__cardBody",
  "cardMain": "Cart-module__Lov9ca__cardMain",
  "cardMobile": "Cart-module__Lov9ca__cardMobile",
  "cardPricing": "Cart-module__Lov9ca__cardPricing",
  "cardSubtitle": "Cart-module__Lov9ca__cardSubtitle",
  "cardSubtitle2": "Cart-module__Lov9ca__cardSubtitle2",
  "cardTitle": "Cart-module__Lov9ca__cardTitle",
  "cardTitle2": "Cart-module__Lov9ca__cardTitle2",
  "cardTop": "Cart-module__Lov9ca__cardTop",
  "detailLabel": "Cart-module__Lov9ca__detailLabel",
  "detailRow": "Cart-module__Lov9ca__detailRow",
  "details": "Cart-module__Lov9ca__details",
  "emptyImage": "Cart-module__Lov9ca__emptyImage",
  "emptyState": "Cart-module__Lov9ca__emptyState",
  "homeButton": "Cart-module__Lov9ca__homeButton",
  "image": "Cart-module__Lov9ca__image",
  "imagePlaceholder": "Cart-module__Lov9ca__imagePlaceholder",
  "imageThumb": "Cart-module__Lov9ca__imageThumb",
  "imageWrap": "Cart-module__Lov9ca__imageWrap",
  "itemsColumn": "Cart-module__Lov9ca__itemsColumn",
  "layout": "Cart-module__Lov9ca__layout",
  "loadingWrap": "Cart-module__Lov9ca__loadingWrap",
  "mobileFooter": "Cart-module__Lov9ca__mobileFooter",
  "mobileFooterCopy": "Cart-module__Lov9ca__mobileFooterCopy",
  "mobileFooterLabel": "Cart-module__Lov9ca__mobileFooterLabel",
  "mobileFooterTotal": "Cart-module__Lov9ca__mobileFooterTotal",
  "mobileFooterTotalRow": "Cart-module__Lov9ca__mobileFooterTotalRow",
  "mobileTitleWrap": "Cart-module__Lov9ca__mobileTitleWrap",
  "moduleTag": "Cart-module__Lov9ca__moduleTag",
  "page": "Cart-module__Lov9ca__page",
  "radioInput": "Cart-module__Lov9ca__radioInput",
  "removeBtn": "Cart-module__Lov9ca__removeBtn",
  "removeClose": "Cart-module__Lov9ca__removeClose",
  "removeConfirmBtn": "Cart-module__Lov9ca__removeConfirmBtn",
  "removeConfirmBtnDiv": "Cart-module__Lov9ca__removeConfirmBtnDiv",
  "removeHeader": "Cart-module__Lov9ca__removeHeader",
  "removeImageWrap": "Cart-module__Lov9ca__removeImageWrap",
  "removeModalRoot": "Cart-module__Lov9ca__removeModalRoot",
  "removeOverlay": "Cart-module__Lov9ca__removeOverlay",
  "removePreview": "Cart-module__Lov9ca__removePreview",
  "removeSheet": "Cart-module__Lov9ca__removeSheet",
  "removeSubtitle": "Cart-module__Lov9ca__removeSubtitle",
  "removeTitle": "Cart-module__Lov9ca__removeTitle",
  "saveBadge": "Cart-module__Lov9ca__saveBadge",
  "selectBtn": "Cart-module__Lov9ca__selectBtn",
  "selectBtnActive": "Cart-module__Lov9ca__selectBtnActive",
  "selectWrap": "Cart-module__Lov9ca__selectWrap",
  "summaryCard": "Cart-module__Lov9ca__summaryCard",
  "summaryTitle": "Cart-module__Lov9ca__summaryTitle",
  "summaryTotal": "Cart-module__Lov9ca__summaryTotal",
  "summaryTotalDiv": "Cart-module__Lov9ca__summaryTotalDiv",
  "textClamp2": "Cart-module__Lov9ca__textClamp2",
  "totalPrice": "Cart-module__Lov9ca__totalPrice",
  "totalRow": "Cart-module__Lov9ca__totalRow",
  "unitPrice": "Cart-module__Lov9ca__unitPrice",
});
